import { Routes, Route, Navigate } from "react-router-dom";
import { Exchange, AccountInfo, Account, VIP, Widget, ConnectionPage } from "../components/pages";
import { useAppSelector } from "../services/hooks.service";
import { PrivateRoute } from "./";
import Affiliate from "../components/pages/Affiliate/Affiliate";
import { equalsIgnoreCase } from "../_utils";
import { AffDashboardVisibilitySettingEnum, POINTS_SETTING } from "../interfaces";

export const ROUTES = {
  account: "/account",
  trade: "/",
  points: "/points",
  widget: "/widget"
}

export const PublicRoutes = () => {
  const isActiveObdex = useAppSelector((state) => state.settings?.obdex);
  const isActivePoints = useAppSelector((state) => state.settings?.pointSystem);
  const affSetting = useAppSelector((state) => state?.settings.affiliateDashboardVisibility);
  const isAffiliateVisible = useAppSelector((state) => state?.user.isAffiliatePageEnabled);

  return (
    <Routes>
      <Route path="/" element={
        <PrivateRoute isActive={!!isActiveObdex} redirect={"/amm/swap"}>
          <Exchange />
        </PrivateRoute>
      } />
      {/* <Route path="amm/*" element={
        // <PrivateRoute isActive={false} redirect={"/"}>
        //   <AMM />
        // </PrivateRoute>
      } /> */}
      <Route path="/account" element={<Account />} />
      <Route path="/points" element={
        <PrivateRoute isActive={!equalsIgnoreCase(isActivePoints, POINTS_SETTING.OFF)} redirect={"/"}>
          <VIP />
        </PrivateRoute>
      } />
      <Route path="/affiliate" element={
        <PrivateRoute 
          isActive={(equalsIgnoreCase(affSetting, AffDashboardVisibilitySettingEnum.ENABLED_FOR_ALL) || isAffiliateVisible)} 
          redirect={"/"}
        >
          <Affiliate />
        </PrivateRoute>
      } />
      <Route path="/widget" element={<Widget />} />
      <Route path="/connect" element={<ConnectionPage />} />
      <Route path="/getaccountinforoute" element={<AccountInfo />} />
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
};
